// One-liner display for an order line item, used by the admin order table and
// the buyer's Orders page. Matches the Python `format_item_display` helper on
// the backend so slip PDF, receipt email, admin, and buyer surfaces all show
// the same shape.
//
//   Name · <mg strength> · <vial-count label>            (regular product)
//   Name · … [inner1 5mg, inner2 10mg, …]                (BYOK kit)
export function formatItemDisplay(item) {
  if (!item) return "";
  const name = String(item.name || "").trim();
  const parts = name ? [name] : [];
  const mgRaw = String(item.variant_mg || "").trim();
  const mg = mgRaw ? (mgRaw.toLowerCase().endsWith("mg") ? mgRaw : `${mgRaw}mg`) : "";
  if (mg) parts.push(mg);
  const unitLabel = String(item.unit_label || "").trim();
  // Skip unit_label if it just repeats the mg strength we already showed.
  if (unitLabel && unitLabel.toLowerCase() !== (mgRaw ? `${mgRaw.toLowerCase()}mg` : "")) {
    parts.push(unitLabel);
  }
  let display = parts.length ? parts.join(" · ") : name;
  if (item.is_byok_kit && Array.isArray(item.byok_items) && item.byok_items.length) {
    const picks = item.byok_items
      .map((b) => {
        const bname = String(b?.name || "").trim();
        const bmgRaw = String(b?.variant_mg || "").trim();
        const bmg = bmgRaw ? (bmgRaw.toLowerCase().endsWith("mg") ? bmgRaw : `${bmgRaw}mg`) : "";
        return bmg ? `${bname} ${bmg}`.trim() : bname;
      })
      .filter(Boolean);
    if (picks.length) display = `${display} [${picks.join(", ")}]`;
  }
  return display;
}
